<template>
  <div class="config_main_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item"
                      @click.native="configGoPreviousPageHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/zuofanhui.png"
               alt />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">设置管理</div>
        </top-nav-item>
        <top-nav-item class="right_item"
                      @click.native="configReturnContronBtnHandle">
          <img class="main_top_img"
               slot="topnavimg"
               src="~assets/img/topnav/shebei_home.png"
               alt />
        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

        <config-hang @click.native="accountNumberBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shebei_zhanghao.png"
               alt="" />
          <span slot="config_hang_ele2">账号管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="" />
        </config-hang>

        <!-- 只有主账号才显示设备管理 -->
        <config-hang v-if="userType === '0'"
                     @click.native="deviceManageBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shebei_guanli.png"
               alt="" />
          <span slot="config_hang_ele2">设备管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="" />
        </config-hang>

        <config-hang v-if="userType === '0'"
                     @click.native="sceneManageBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shebei_changjing.png"
               alt="" />
          <span slot="config_hang_ele2">场景管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="" />
        </config-hang>

        <config-hang v-if="userType === '0'"
                     @click.native="groupManageBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/hostname.png"
               alt="" />
          <span slot="config_hang_ele2">组管理</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="" />
        </config-hang>

        <config-hang @click.native="aboutPageBtnHandle">
          <img slot="config_hang_ele1"
               src="~assets/img/config/shebei_guanyu.png"
               alt="" />
          <span slot="config_hang_ele2">关于</span>
          <img slot="config_hang_ele4"
               src="~assets/img/config/youjiantou.png"
               alt="" />
        </config-hang>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
export default {
  data () {
    return {
      userType: sessionStorage.getItem('userType') ////获取子账号和主账号的状态  0主账号1子账号
    }
  },
  components: {
    topNav,
    topNavItem,
    configHang
  },
  methods: {
    configGoPreviousPageHandle () {
      ///导航栏返回按钮
      this.$router.go(-1)
    },
    sceneManageBtnHandle () {
      ///场景管理按钮
      this.$router.push('/ConfigSceneMain')
    },
    //代号 20231207-1
    groupManageBtnHandle () {
      ///组管理按钮
      this.$router.push('/ConfigGroupMain')
    },
    accountNumberBtnHandle () {
      ///账号管理按钮按下了  ///判断一下是主张还是子账号
      if (this.userType === '0') {
        ///说明是主账号
        this.$router.push('/AccountNumberMain')
      } else if (this.userType === '1') {
        ///说明是子账号
        this.$router.push('/AccountNumberMain/changeSonPassWord')
      }
    },
    configReturnContronBtnHandle () {
      ////配置页面的主页返回按钮被点击了
      this.$router.replace(this.$store.state.publicinfo.configReturnPath)
    },
    deviceManageBtnHandle () {
      ///设备管理按钮被点击了
      this.$router.push('/DeviceManageMain')
    },
    aboutPageBtnHandle () {
      console.log('关于按钮被点击了')
      // this.$router.push('/aboutPage')
      this.$router.push({ path: '/aboutPage', query: { type: 'afterLogin' } })
    }
  },

  mounted () {
    console.log('mounted阶段')
  },
  created () {
    // console.log("created阶段");
    // /// 请求区域信息接口，获取数据
    // this.$request({
    //   method: "post",
    //   url: "/region/findRegion",
    //   data: {
    //     token: this.$store.state.token
    //   }
    // })
    //   .then(res => {
    //     if (res.data.code != 0) {
    //       this.$showTipsToast(3, res.data.message);
    //       ////说明信息填写错误,控制失败了，
    //       return;
    //     } else {
    //       ////、控制成功了
    //       this.serveRegionListData = res.data.data; ////拿到服务器返回的数据结果
    //       // this.$showTipsToast(1, "获取成功", true); ////提示框
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }
}
</script>

<style></style>
